import React, { useEffect, useState } from "react";
import "./Form.css";
import { GoArrowUpRight } from "react-icons/go";
import { AiFillFilePdf } from "react-icons/ai";
import Aos from "aos";
import Swal from "sweetalert2";
import { Link } from "react-router-dom";

function Form() {
  useEffect(() => {
    Aos.init({
      duration: 500, // Duration of animation
      easing: "ease-in-out", // Easing function
    });
  }, []);

  const [formDataa, setFormDataa] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  });
  const [loading, setLoading] = useState(false); // New loading state

  const handleChange = (e) => {
    setFormDataa({
      ...formDataa,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (
      !formDataa.name ||
      !formDataa.phone ||
      !formDataa.email ||
      !formDataa.message
    ) {
      alert("Please fill in all fields");
      return;
    }

    setLoading(true); // Set loading to true when starting submission

    try {
      const response = await fetch(
        "https://script.google.com/macros/s/AKfycby3G3TAv_Bwtn3IISYbayKpzguCHnMCb4XVGKCMyIh_iUCZOoBqgoVPflhPQ-4VYb5_BQ/exec",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
          body: new URLSearchParams(formDataa),
        }
      );

      if (response.ok) {
        Swal.fire({
          title: "Thank you! We'll get back to you soon.",
          icon: "success",
        });

        setTimeout(function () {
          window.location.reload();
        }, 3000);
      } else {
        throw new Error("Something went wrong");
      }
    } catch (error) {
      Swal.fire({
        title: "Error!",
        text: "Something went wrong. Please try again later.",
        icon: "error",
      });
    } finally {
      setLoading(false); // Set loading to false once the submission is finished
    }
  };
  return (
    <div id="formz" className="FormDiv">
      <div className="forminner">
        <div
          className="formsideA"
          data-aos="fade-right"
          data-aos-duration="500"
        >
          <span> GET IN TOUCH NOW</span>
          <h1>
            It’s good to be <br /> home
          </h1>
          <p className="pa">
            Our home care specialist will provide a free consultation to discuss
            and create your personally tailored care plan.
          </p>

          <button>
            <a href="#site">
              VIEW MORE <GoArrowUpRight className="Arr" />
            </a>
          </button>
        </div>

        <div className="formsideB" data-aos="fade-up" data-aos-duration="800">
          <div className="form">
            <span>
              <AiFillFilePdf className="i" />
              Let's Connect
            </span>

            <div className="inp2">
              <input
                type="text"
                id="name"
                name="name"
                placeholder="Full Name"
                required
                value={formDataa.name}
                onChange={handleChange}
              />{" "}
              <input
                type="text"
                placeholder="Enter your mail"
                id="email"
                name="email"
                required
                value={formDataa.email}
                onChange={handleChange}
              />
            </div>

            <input
              className="num"
              type="text"
              id="phone"
              name="phone"
              placeholder="Your phone"
              required
              value={formDataa.phone}
              onChange={handleChange}
            />

            <input
              className="enq"
              type="text"
              placeholder="message"
              id="message"
              name="message"
              required
              value={formDataa.message}
              onChange={handleChange}
            />
            <div className="radioo">
              <span className="consent-header">
                Consent for storing submitted data
                <span className="required">*</span>
              </span>



              <div className="consent-checkbox">


                <span>
                  <input type="checkbox" id="consent" name="consent" required />
                  By ticking this box I consent to JR Care Ltd using the
                </span>
                <span className="dspa"> information as per the <Link to="/privacy" className="liko"> privacy policy. </Link></span>

                

              </div>




            </div>
            <button
              type="submit"
              className="form-btn"
              id="cf-submit"
              name="submit"
              onClick={handleSubmit}
              disabled={loading} // Disable button while loading
            >
              {loading ? (
                <div
                  className="spinner-border text-success active"
                  role="status"
                >
                  <span className="sr-only">Loading...</span>
                </div>
              ) : (
                "Submit"
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Form;
